import request from '@/utils/request'

// 超管概览页
// 批次数
export const getBatchNum = () => {
  return request({
    url: '/trace/gov/index/batch/num'
  })
}

// 当年销售情况排名
export const getMerchantReport = () => {
  return request({
    url: '/trace/gov/index/merchant/report'
  })
}

// 订单报表
export const getOrderReport = () => {
  return request({
    url: '/trace/gov/index/order/report'
  })
}

// 产品 总数、在产数、停产
export const getProductNum = () => {
  return request({
    url: '/trace/gov/index/product/num'
  })
}

// 溯源码 总数、已打印、未打印
export const getQrcodeNum = () => {
  return request({
    url: '/trace/gov/index/qrcode/num'
  })
}

// 人员总数
export const getUserNum = () => {
  return request({
    url: '/trace/gov/index/user/num'
  })
}
